$(function () {

    $('.newsletter_section__arrow').on('click', function (e) {

        // Prevent default action
        e.preventDefault();

        // Scroll to cta section
        $('html, body').animate({
            scrollTop: 0
        }, 500);

    });

});